import { Box, Pressable } from '@rbilabs/universal-components';

export const CloseButtonWrapper = Box.withConfig({
  position: 'absolute',
  top: '$0',
  right: '$0',
  bottom: '$0',
});

export const PressableButton = Pressable.withConfig({
  flex: 1,
  width: { base: '$14', md: '$20' },
  justifyContent: 'center',
  alignItems: 'center',
  hitSlop: 10,
});
